import Album from "../../components/album/Album";
import styles from "./LongAp.module.css";

export default function LongAp() {
  return (
    <div className={styles["long-ap"]}>
      <br></br>
      <br></br>
      <Album
        albumName={`Góp ý của khán giả cho bài nói chuyện "Thích Gì Làm Nấy... nghe đơn giản nhưng vì sao khó tới vậy" (9/3/25)`}
        folderName="essays/thich-j-lam-nay"
      />
      <p className={styles.announce}>
        Cảm ơn các bạn đã phản hồi và cho cảm nhận, Hoan sẽ tiếp thu để điều
        chỉnh tới bến :))
      </p>
      <br></br>
      <br></br>

      <Album
        albumName="Phong Cách Riêng: Hoạ Sĩ Tìm Ở Đâu"
        folderName="essays/styles-n-fundamentals"
      />

      <p className={styles.announce}>
        Bài essay này khơi mào chuỗi hoạt động "Chiếc Lồng Ấp" vào tháng 1/2023.
        Sau đó trong tháng 3/2023 tụi mình cũng đã tổ chức một buổi offline để 6
        người bạn cùng chia sẻ về hành trình vào nghề và làm nghề.
      </p>
      <br></br>

      {/* TODO: LongAp #2 Album */}

      <p className={styles.announce}>
        Tụi mình hy vọng sẽ quay trở lại sớm để có thêm các thảo luận thiết thực
        trong 2025.
      </p>
    </div>
  );
}
